/**
 * Identifica se um erro recebido em .catch é resultado de cancelamento
 * (AbortController.abort()), seja via axios 1.x (CanceledError /
 * ERR_CANCELED) ou fetch nativo (AbortError).
 *
 * Use no catch de thunks para distinguir cancelamento de erro real —
 * em caso de cancelamento, NÃO chamar callbacks de UI (setLoading,
 * setRows, setAlert) porque o componente já desmontou ou um novo
 * request vai atualizar o state.
 */
export const isAbortError = (error) => {
	if (!error) return false;
	if (error.code === "ERR_CANCELED") return true;
	if (error.name === "AbortError" || error.name === "CanceledError") return true;
	if (error.message === "canceled") return true;
	return false;
};
